import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const MicrophoneIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <g clipPath="url(#clip0_1290_4996)">
      <path
        d="M4.5 9.75C4.6875 11.0192 5.625 13.5577 9 13.5577M9 13.5577C12.375 13.5577 13.3125 11.0192 13.5 9.75M9 13.5577V15.9375"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M9 2.75C9.49391 2.75 9.89757 2.9171 10.2402 3.25977C10.5829 3.60243 10.75 4.00609 10.75 4.5V9C10.75 9.43209 10.6218 9.79487 10.3604 10.1084L10.2402 10.2402C9.89757 10.5829 9.49391 10.75 9 10.75C8.56791 10.75 8.20513 10.6218 7.8916 10.3604L7.75977 10.2402C7.4171 9.89757 7.25 9.49391 7.25 9V4.5C7.25 4.06791 7.37819 3.70513 7.63965 3.3916L7.75977 3.25977C8.10243 2.9171 8.50609 2.75 9 2.75Z"
        stroke="currentColor"
      />
    </g>
  </svg>
);
